module.exports = __webpack_public_path__ + "static/media/Video script - reduced sugar does not mean reduced calories 3_1583762522509.894d778c.6";